import isString from 'lodash/isString';
import { fData } from '../../utils/formatNumber';
import Iconify from '../Iconify';

// ----------------------------------------------------------------------

const getFileData = (file) => {
  if (typeof file === 'string') {
    return {
      key: file,
    };
  }
  return {
    key: file.name,
    name: file.name,
    size: file.size,
    preview: file.preview,
  };
};

export default function MultiPreviewNamesList({ showPreview = true, files, onRemove, onRemoveAll }) {
  const hasFile = files?.length > 0;

  return (
    <>
      {hasFile && (
        <ul className="list-none p-0 my-3 space-y-2">
          {files.map((file, index) => {
            const { key, name, size, preview } = getFileData(file);

            return (
              <li
                key={index}
                className="flex items-center gap-3 px-3 py-2 rounded-lg border border-gray-100 dark:border-[#383838] bg-gray-50 dark:bg-[#1A1D21]"
              >
                <Iconify icon="eva:file-fill" className="w-7 h-7 text-gray-400 dark:text-[#ABABAD] flex-shrink-0" />

                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 dark:text-[#D1D2D3] truncate">
                    {isString(file) ? file : name}
                  </p>
                  {!isString(file) && (
                    <p className="text-xs text-gray-500 dark:text-[#ABABAD]">
                      {fData(size || 0)}
                    </p>
                  )}
                </div>

                <button
                  onClick={() => onRemove(file)}
                  className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-md text-gray-400 dark:text-[#ABABAD] hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 transition-colors"
                >
                  <Iconify icon="eva:close-fill" className="w-5 h-5" />
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}
